// extracted by mini-css-extract-plugin
module.exports = {"btnDrop":"index_btnDrop_2p_DB"};